module.exports = __webpack_public_path__ + "static/media/tree-plus.3b16bb99.svg";